export const AUDIO_SEEK_TIME_IN_S = 5;

export const PLAYBACK_SPEED_OPTIONS = [
  { value: '1', label: '1x' },
  { value: '1.25', label: '1.25x' },
  { value: '1.5', label: '1.5x' },
  { value: '1.75', label: '1.75x' },
  { value: '2', label: '2x' },
] as const;
